
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import type { StepInput } from '../types/form'

@Component({
    name: 'FormCheckboxGroup',
    components: {
        EditorViewer,
    },
})
export default class FormCheckboxGroup extends Vue {
    @Prop() data!: StepInput
    @Prop() language!: string
    @Prop() required!: boolean
    @Prop() value!: string[]

    selected = this.value || []

    @Watch('value')
    handleValueChange() {
        this.selected = this.value || []
    }
}
